import { ContratsDashboardView } from "@features/home-dashboard/contrats";
import { useCurrentUser } from "@lib/hooks/useCurrentUser";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/(dashboard)/contrats/me/")({
  staticData: {
    title: "Mes Contrats",
    section: "Général",
    order: 60,
    showInTab: true,
    showInBreadcrumb: true,
  },
  component: ContratsMeRoute,
});

function ContratsMeRoute() {
  // This fetches and populates the user store with personne data
  useCurrentUser();

  return <ContratsDashboardView />;
}
